webpackJsonp([260673665570375],{

/***/ 2000:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"RowUploadError","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"row","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"String","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-row-upload-error-3f490d447b61caa3952a.js